import Star from 'assets/icons/star.svg';
import Notes from 'assets/icons/notes.svg';
import Atoms from 'assets/icons/atoms.svg';
import Adding from 'assets/icons/adding.svg';
import Android from 'assets/icons/android.svg';
import Architer from 'assets/icons/architer.svg';
import Analytics from 'assets/icons/analytics.svg';

const contentProps = { justifyContent: 'center' };

export const defaultTechExpertData = {
  title: (
    <>
      Подбираем ИТ-специалистов
      <br /> по всем направлениям
    </>
  ),

  cardsData: [
    {
      title: 'Системный и бизнес-анализ',
      tabIcon: Architer,
      content:
        'Один из самых многочисленных департаментов компании. <br /> 70% сотрудников — специалисты среднего и ведущего уровней (Middle и Senior). <br /> Выявляем проблемы и потребности бизнеса, прогнозируем результаты и работаем с данными.',
      contentProps,
    },
    {
      title: '1С-разработка',
      link: '/1C',
      tabIcon: Notes,
      content:
        'Внедряем прикладные решения на платформе 1С, применяем типовые конфигурации, обеспечиваем интеграцию с работающими системами. Работаем с 1С:ERP 2.0, 1С:ЗУП КОРП, 1С:Битрикс и другими.',

      contentProps,
    },
    {
      title: 'Проверка качества',
      tabIcon: Analytics,
      content:
        'Наши опытные инженеры вовлечены в процесс разработки на всех этапах, начиная с составления технического задания. В работе мы используем только передовые решения и методы.',
      contentProps,
    },
    {
      title: 'Мобильная разработка',
      tabIcon: Android,
      content:
        'Создаём пользовательские мобильные решения для бизнеса, конечных клиентов и сотрудников компаний (для b2b, b2c, b2e). Обеспечиваем полный цикл разработки: предлагаем дизайн, разрабатываем цифровое решение, тестируем и обеспечиваем техподдержку.',
      contentProps,
    },
    {
      title: 'Разработка серверной части (Backend)',
      tabIcon: Atoms,
      content:
        'Опытные специалисты ASTON создают уникальные цифровые решения с применением актуальных библиотек и программных платформ. Мы не просто пишем код, а предлагаем решения, которые сделают ваш продукт лучше.',
      contentProps,
    },
    {
      title: 'Разработка интерфейсов (Frontend)',
      tabIcon: Adding,
      content:
        'Создаём удобные и интерактивные пользовательские интерфейсы, дорабатываем существующие цифровые продукты и обеспечиваем техническую поддержку.',
      contentProps,
    },
    {
      title: 'Другие направления',
      tabIcon: Star,
      content:
        'Активно развиваем востребованные на рынке технологии. Всего в команде более 2 тыс. специалистов, обладающих знаниями по всем ИТ\u2011направлениям.',
      contentProps,
    },
  ],
};
